import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class UserRolesService {

  constructor() { }
  isRole(role) {
    let exists = false;
    const local = JSON.parse(localStorage.getItem('roles'));
    local.forEach(element => {
      if (role === element.value) {
        exists = true;
        return exists;
      }
    });
    return exists;
  }
}
